import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=5b62a113&scoped=true&"
import script from "./NewCustomer.vue?vue&type=script&lang=js&"
export * from "./NewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=5b62a113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62a113",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
